import Icon from '../components/Icon.vue'

Icon.register({
  'user-lock': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M224 256c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128-57.3 128-128 128zM320 320v160c0.1 9.5 4.1 23.8 8.9 32h-280.9c-26.5 0-48-21.5-48-48v-41.6c0-74.2 60.2-134.4 134.4-134.4h16.7c19.2 8.8 51.8 16 72.9 16s53.7-7.2 72.9-16h16.7c5 0 9.7 1 14.5 1.5-4.4 7.8-8 21.5-8.1 30.5zM608 288c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32v-160c0-17.7 14.3-32 32-32h32v-80c0-44.2 35.8-80 80-80s80 35.8 80 80v80h32zM496 432c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM528 288v-80c0-17.7-14.3-32-32-32s-32 14.3-32 32v80h64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-lock.js
// module id = 2065
// module chunks = 0